// src/lib/createStudentAuth.js
// Creates Firebase Auth users via a SECONDARY app instance so the admin's own
// session is never replaced. (createUserWithEmailAndPassword on the primary auth
// would sign the admin out and in as the new user — the well-known client-SDK
// limitation when you have no Cloud Functions / Admin SDK backend.)

import { initializeApp, getApps } from "firebase/app";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signOut,
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBmqWcksNai_pZIhGsrIFKWM9xhkKZAmDY",
  authDomain: "ravi-edu.firebaseapp.com",
  projectId: "ravi-edu",
  storageBucket: "ravi-edu.firebasestorage.app",
  messagingSenderId: "236027925555",
  appId: "1:236027925555:web:754c52476578fb95a17f46",
};

const SECONDARY_NAME = "studentCreator";

function getSecondaryAuth() {
  const existing = getApps().find((a) => a.name === SECONDARY_NAME);
  const app = existing || initializeApp(firebaseConfig, SECONDARY_NAME);
  return getAuth(app);
}

// Creates a new student auth account and returns its uid. Does NOT touch the
// primary (admin) session.
export async function createStudentAccount({ email, password }) {
  const secondaryAuth = getSecondaryAuth();
  try {
    const { user } = await createUserWithEmailAndPassword(secondaryAuth, email, password);
    const uid = user.uid;
    return uid;
  } finally {
    // Always sign the secondary session out so it doesn't linger.
    try { await signOut(secondaryAuth); } catch (_) {}
  }
}
